module.exports = __webpack_public_path__ + "img/horizontal_7_6_9016.da0339d9.png";